// extracted by mini-css-extract-plugin
export default {"note":"Note_note__ypuKC","noteContent":"Note_noteContent__wOkUE","noteLogo":"Note_noteLogo__bTtMn","noteTitle":"Note_noteTitle__q9VNi"};